import { Outlet } from 'react-router-dom'
import { useAuth } from '../../context/auth-context'

export default function ProtectedRoutes() {
  const { isAuthenticated, authenticate } = useAuth()
  if (!isAuthenticated) {
    authenticate()
    return null
  }

  return <Outlet />
}
